import { render, staticRenderFns } from "./CasinoOptionsConfiguration.vue?vue&type=template&id=45be98d6&scoped=true&"
import script from "./CasinoOptionsConfiguration.vue?vue&type=script&lang=js&"
export * from "./CasinoOptionsConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be98d6",
  null
  
)

export default component.exports